Shopify = Shopify || {}
Shopify.theme = Shopify.theme || {}
/*************** BEE LAZY & BEE PERFECT SIZE ***************/
Shopify.theme.images = {

    bee_lazy_class : 'bee_lazy',
    bee_perfect_size_class : 'bee_perfect_size',
    bee_data_sizes : [50,100,150,250,400,500,750,1000,1500,1920,2560,3440,4096,5120],

    init : function(){
        this.beeLazy()
        let that = this;
        window.addEventListener('resize', (event) => {
            that.beePerfectSizeAll()
        });
        window.addEventListener('beelazy', (event) => {
            that.beeLazy()
        });
        if (Shopify.designMode) {
            window.addEventListener('shopify:section:load', function(){
                window.dispatchEvent(new Event('beelazy'));
            });
        }
        
    },
    observerOptions: { 
        rootMargin: '0px 0px 50px 0px', 
        threshold: 1.0  
    },
    imageObserver : new IntersectionObserver(function (entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                Shopify.theme.images.imageObserver.unobserve(entry.target);
                Shopify.theme.images.beePerfectSize(entry.target)
            }
        })
    },this.observerOptions),
    beeLazy : function(){
        document.querySelectorAll('.'+ this.bee_lazy_class).forEach(element =>{
            this.imageObserver.observe(element);
        })
    },
    beePerfectSize : function(element){
        element.src = element.getAttribute('data-src').replace('_1x1','_' +  this.getNextSize(element.offsetWidth) + 'x');
        element.classList.add( this.bee_perfect_size_class)
        element.setAttribute('width',element.offsetWidth)
        element.setAttribute('height',element.offsetHeight)
    },
    beePerfectSizeAll : function(){
        document.querySelectorAll('.'+ this.bee_perfect_size_class).forEach(element =>{
            element.src = element.getAttribute('data-src').replace('_1x1','_' +  this.getNextSize(element.offsetWidth) + 'x');
            element.classList.add( this.bee_perfect_size_class)
            element.setAttribute('width',element.offsetWidth)
            element.setAttribute('height',element.offsetHeight)
        })
        
    },
    getNextSize : function(x) {
        for (let i = 0; i < this.bee_data_sizes.length; i++) {
            if(this.bee_data_sizes[i] >= x){
                return this.bee_data_sizes[i];
            }
        }
        return this.bee_data_sizes[this.bee_data_sizes.length - 1]
    }  
};
Shopify.theme.images.init();
/*************** DOM ***************/
Shopify.theme.dom = {
    init : function(){
        let that = this;
        this.calculateMainMinHeight()
        window.addEventListener('resize', (event) => {
            that.calculateMainMinHeight()
        });
    },
    calculateMainMinHeight : function(){
        document.querySelector('main').style.minHeight = 'calc(100vh - ' + document.querySelector('header').offsetHeight + 'px - ' + document.querySelector('footer').offsetHeight +'px)'
    }
};
Shopify.theme.dom.init();
/*************** LINKS ***************/
Shopify.theme.links = {
    init : function(){
        document.querySelectorAll('a').forEach(
            element => {
                /*************** SCROLL TO VIEW ***************/
                if(element.href.includes('#')){
                    element.addEventListener('click',function(event){
                        let hash = element.href.split('#')[1];
                        let web = element.href.split('#')[0];
                        //event.preventDefault()
                        if(hash != ''){
                            //window.open(web+'#'+hash,"_self")
                            window.scrollTo(0,document.getElementById(hash).offsetTop)
                        }
                    })
                }
                /*************** PREFETCH LINKS ***************/
                else{
                    if (false) {
                        if (!element.href.includes('mailto:')) {
                            let newPrefetch = document.createElement('link');
                            newPrefetch.rel = "prefetch";
                            newPrefetch.href = element.href;
                            document.head.appendChild(newPrefetch);
                        }
                    
                    }
                }
            }
        )
    }
}
Shopify.theme.links.init();
/*************** TOOLS ***************/
Shopify.theme.tools = {
    init: function(){
       /* window.addEventListener('resize',function(){
            document.querySelector(':root').style.setProperty('--vh', window.innerHeight/100 + 'px');
            document.querySelector(':root').style.setProperty('--vw', window.innerWidth/100 + 'px');
        })
        document.addEventListener('DOMContentLoaded',function(){
            document.querySelector(':root').style.setProperty('--vh', window.innerHeight/100 + 'px');
            document.querySelector(':root').style.setProperty('--vw', window.innerWidth/100 + 'px');
        })*/
    },
    handleize: function(value){
        let handle =  value.toString().split(' ').join('-');
        handle = handle.toLowerCase();
        return handle
    },
    formatMoney: function (cents, format){
        let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        let money_format = format;
        switch(money_format.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, ".", ",");
                break;
            case "amount_with_apostrophe_separator":
                value = formatWithDelimiters(cents, 2, "'", ".");
                break;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = (typeof precision != 'undefined' ? precision : 2);
            thousands = (typeof thousands != 'undefined' ? thousands : ".");
            decimal   = (typeof decimal != 'undefined' ? decimal : ",");

            if (isNaN(number) || number == null) { return 0; }

            number = (number/100.0).toFixed(precision);

            var parts   = number.split('.');
            let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            let cents   = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }
        return money_format.replace(placeholderRegex, value)
    },
    /*************** SHOPIFY COMMON.JS (PROVINCE SELECTOR) ***************/
    bind: function(t,e){
        return function(){
          return t.apply(e,arguments)
        }
    },
    setSelectorByValue: function(t,e){
        for(var n=0,i=t.options.length;n<i;n++)
        {
            var o=t.options[n];
            if(e==o.value||e==o.innerHTML)
                return t.selectedIndex=n
        }
    },
    postLink: function(t,e){
        var n = ( e = e || {}).method || "post";
        i = e.parameters || {};
        o = document.createElement("form");
        for(var r in o.setAttribute("method", n),o.setAttribute("action",t),i){
            var l = document.createElement("input");
            l.setAttribute("type","hidden");
            l.setAttribute("name",r);
            l.setAttribute("value",i[r]);
            o.appendChild(l)
        }
        document.body.appendChild(o);
        o.submit();
        document.body.removeChild(o);
    }
}

Shopify.theme.tools.CountryProvinceSelector = function(t,e,n){
    this.countryEl = document.getElementById(t);
    this.provinceEl = document.getElementById(e);
    this.provinceContainer = document.getElementById(n.hideElement||e);
    this.countryEl.addEventListener('change', Shopify.theme.tools.bind(this.countryHandler, this));
    this.initCountry();
    this.initProvince();
}

Shopify.theme.tools.CountryProvinceSelector.prototype = {
    initCountry: function(){
        var t = this.countryEl.getAttribute("data-default");
        Shopify.theme.tools.setSelectorByValue(this.countryEl,t);
        this.countryHandler();
    },
    initProvince: function(){
        var t=this.provinceEl.getAttribute("data-default");
        t && 0 < this.provinceEl.options.length && Shopify.theme.tools.setSelectorByValue(this.provinceEl,t);
    },
    countryHandler: function(){
        var t=(i=this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces");
        e=JSON.parse(t);
        if(this.clearOptions(this.provinceEl),e&&0==e.length)
            this.provinceContainer.style.display="none";
        else{
            for(var n=0;n<e.length;n++){
                var i;(i=document.createElement("option")).value=e[n][0];
                i.innerHTML=e[n][1],this.provinceEl.appendChild(i);
            }
            this.provinceContainer.style.display = "";
        }
    },
    clearOptions: function(t){
        for(;t.firstChild;)
            t.removeChild(t.firstChild);
    },
    setOptions: function(t,e){
        var n=0;
        for(e.length;n<e.length;n++){
            var i=document.createElement("option");
            i.value = e[n];
            i.innerHTML = e[n];
            t.appendChild(i);
        }
    }
}

Shopify.currency.moneyFormat = null;

Shopify.theme.tools.init();
/*************** CART ***************/
Shopify.theme.cart = {
    init : function(){
        let that = this;
        window.addEventListener('cartadd',function(e){
            e.preventDefault();
            that.getCart();
            if ('drawer' == 'redirect') {
                location.pathname = '/cart'
            }
            else if ('drawer' == 'notification') {
                
            }
            else if ('drawer' == 'drawer') {
                window.dispatchEvent(new Event('opencartdrawer'));
            }
        })
    },
    addToCart : function (addData) {
        fetch('/cart/add.js', {
                body: JSON.stringify(addData),
                credentials: 'same-origin',
                headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
                method: 'POST'
            }).then(function(response) {
                if(!response.ok) {
                    response.text().then(text => {
                        let error = JSON.parse(text);
                        console.error(error.status);
                        console.error(error.message);
                        console.error(error.description);
                        if(error.status == 422)
                            window.alert(error.description);
                    })
                } else {
                   return response.json();
                }   
            }).then(function(product) {
                let addevent = new CustomEvent("cartadd", {detail:{product}});
                window.dispatchEvent(addevent);
            }).catch(function(err) {
                console.error(err);
            }
        );
    },
    getCart: function (){
        let that = this;
        fetch('/cart.js', {
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
            method: 'GET'
            }).then(function(response) {
                return response.json();
            }).then(function(cart) {
                let event = new CustomEvent("cartdatachanged", {detail:{cart}});
                window.dispatchEvent(event);
            }).catch(function(err) {
                console.error(err)
            });
    },
    // Example input: { updates: { 12345678: 2, 87654321: 3 } }
    updateCart: function (itemsToUpdate){
        let that = this;
        fetch('/cart/update.js', {
            body: JSON.stringify(itemsToUpdate),
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
            method: 'POST'
        }).then(function(response) {
            if(!response.ok) {
                response.text().then(text => {
                    let error = JSON.parse(text);
                    console.error(error.status);
                    console.error(error.message);
                    console.error(error.description);
                })
            } else {
               return response.json();
            }   
        }).then(function(cart) {
            let event = new CustomEvent("cartdatachanged", {detail:{cart}});
            window.dispatchEvent(event);
        }).catch(function(err) {
            console.error(err)
        });
    },
    clearCart: function (){
        fetch('/cart/clear.js', {
            body: '',
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
            method: 'POST'
            }).then(function(response) {
                if(!response.ok) {
                    response.text().then(text => {
                        let error = JSON.parse(text);
                        console.error(error.status);
                        console.error(error.message);
                        console.error(error.description);
                    })
                } else {
                   return response.json();
                }   
            }).then(function(cart) {
                let event = new CustomEvent("cartdatachanged", {detail:{cart}});
                window.dispatchEvent(event);
            }).catch(function(err) {
                console.error(err)
            });
    },
    // Example input: { 'id': 794864053, 'quantity': 3 }
    changeItem: function (itemToChange){
        fetch('/cart/change.js', {
            body:  JSON.stringify(itemToChange),
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
            method: 'POST'
            }).then(function(response) {
                if(!response.ok) {
                    response.text().then(text => {
                        let error = JSON.parse(text);
                        console.error(error.status);
                        console.error(error.message);
                        console.error(error.description);
                    })
                } else {
                    return response.json();
                }   
            }).then(function(cart) {
                for (const item of cart.items) {
                    if(item.key == itemToChange.id && item.quantity != itemToChange.quantity)
                        console.error("inventory_quantity reached old quantity remains!");
                }
                let event = new CustomEvent("cartdatachanged", {detail:{cart}});
                window.dispatchEvent(event);
            }).catch(function(err) {
                console.error(err)
            });
    }
};
Shopify.theme.cart.init();

Shopify.theme.animations = {
    init : function(scope){
        scope.querySelectorAll('.animation.on-load').forEach(element => {
            this.animationObserver.observe(element);
        })
    },
    observerOptions: { 
        rootMargin: '0px 0px 50px 0px', 
        threshold: 1.0  
    },
    animationObserver : new IntersectionObserver(function (entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                Shopify.theme.animations.animationObserver.unobserve(entry.target);
                Shopify.theme.animations.triggerAnimation(entry.target);
            }
        })
    },this.observerOptions),
    triggerAnimation : function(target){
        setTimeout(function(){
            target.classList.add('running')
        },target.getAttribute('animation-delay'))
    },
}
Shopify.theme.animations.init(document);

if (Shopify.designMode) {
    window.addEventListener('shopify:section:load', function(e){
        Shopify.theme.animations.init(e.target);
    });
}
